export default {"src":"/_next/static/media/mail.e0bb1db1.svg","height":45,"width":46,"blurWidth":0,"blurHeight":0};